import React, { useRef } from "react";
import RequestList from "./RequestList";
import ListCalendar from "./ListCalendar";
import { Macros } from "../models/Macros";
import { useAppContext } from "../contexts/AppContext";
import { TListCalendarWrapperProps } from "../types/components/ListCalendarWrapper";

type TRequestListCalendarProps = {
    id: number;
    onInfoOpen: (entryIds: number[], showPanel?: boolean) => void;
} & TListCalendarWrapperProps;

const getRefreshEvents = () => [
    Macros.Event.SELECT_RESERVATION,
    Macros.Event.RESERVATION_MADE_OR_MODIFIED,
];

const RequestListCalendar = (props: TRequestListCalendarProps) => {
    const appContext = useAppContext();
    const settingsButton = useRef<any>(null);
    const wrapper = useRef<any>(null);

    const onSelection = (selection) => {
        appContext.fireEvent(`reservationList${props.id}`, Macros.Event.SELECT_REQUEST, selection);
        props.onInfoOpen([selection.id], false);
    };

    return (
        <ListCalendar
            {...props}
            type={"requestList"}
            onSelection={onSelection}
            refreshEvents={getRefreshEvents()}
            settingsRef={(node) => {
                settingsButton.current = node;
            }}
            listRef={(node) => {
                wrapper.current = node;
            }}
        >
            <RequestList />
        </ListCalendar>
    );
};

export default RequestListCalendar;
